/* ==========================================================================
   Collection — sort, and the vehicle chip.

   Filtering was removed in decision 0012, so the price-bucket highlight that
   read the URL back went with it. Two jobs remain:

     1. the sort select — a real form control, submitted on change
     2. the vehicle chip — the session's compatibility check, and the only
        chip on that row; removing it clears the check
   ========================================================================== */
(() => {
  'use strict';

  const SESSION_KEY = 'gp.vehicle';
  const RESULT_KEY = 'gp.result';

  /* ---- Sort ---------------------------------------------------------------- */

  document.querySelectorAll('[data-gp-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });

  /* ---- The vehicle chip ---------------------------------------------------- */

  /* The class this page is scoped to, or null on an unscoped page. The marker
     is emitted by gp-checker.liquid; its absence means all classes are on
     offer here and any carried answer is welcome. */
  const pageClass = () => document.querySelector('[data-gp-scoped]')?.dataset.gpClass || null;

  /* A result scoped to a class other than this page's is treated as absent —
     and so is a result with no `cls` at all, from a session started before
     the class travelled with the answer: an unknown class cannot be shown to
     match. The gp:checked listener below re-reads through this same
     function, so it inherits the gate rather than needing its own. 0012 §2. */
  function readResult() {
    let r;
    try { r = JSON.parse(sessionStorage.getItem(RESULT_KEY) || 'null'); } catch { return null; }
    if (!r) return null;
    const scope = pageClass();
    if (scope && r.cls !== scope) return null;
    return r;
  }

  function clearVehicle() {
    try {
      sessionStorage.removeItem(RESULT_KEY);
      sessionStorage.removeItem(SESSION_KEY);
    } catch { /* private mode */ }
    // A reload is the honest way to clear it: the checker's fields, its result
    // panel and this chip are three views of the same session state, and
    // patching each of them by hand is how they drift apart.
    window.location.reload();
  }

  function paintVehicle() {
    const chip = document.querySelector('[data-gp-vehicle-chip]');
    const note = document.querySelector('[data-gp-vehicle-note]');
    const r = readResult();

    const label = r && r.state === 'supported' ? r.vehicle : '';

    if (chip) {
      const text = chip.querySelector('[data-gp-vehicle-label]');
      if (label && text) {
        text.textContent = chip.dataset.gpTemplate
          ? chip.dataset.gpTemplate.replace('{{ vehicle }}', label)
          : label;
      }
      chip.hidden = !label;
    }
    if (note) {
      const title = note.querySelector('[data-gp-vehicle-note-title]');
      if (title) title.textContent = label;
      note.hidden = !label;
    }
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-gp-vehicle-chip]') || e.target.closest('[data-gp-vehicle-clear]')) {
      e.preventDefault();
      clearVehicle();
    }
  });

  paintVehicle();
  document.addEventListener('gp:checked', paintVehicle);
})();
